import { I18n } from 'src/translations/i18n';
import { toastr } from 'react-redux-toastr';
import toastrError from 'src/helpers/toastr/toastrError';
import { wtsApi } from 'src/api';
export var LawReportActions;
(function (LawReportActions) {
    LawReportActions["GET_LAW_REPORT_REQUEST"] = "GET_LAW_REPORT_REQUEST";
    LawReportActions["GET_LAW_REPORT_SUCCESS"] = "GET_LAW_REPORT_SUCCESS";
    LawReportActions["GET_LAW_REPORT_FAIL"] = "GET_LAW_REPORT_FAIL";
})(LawReportActions || (LawReportActions = {}));
function getLawReportRequest() {
    return { type: LawReportActions.GET_LAW_REPORT_REQUEST };
}
function getLawReportSuccess(payload) {
    return { type: LawReportActions.GET_LAW_REPORT_SUCCESS, payload };
}
function getLawReportFail() {
    return { type: LawReportActions.GET_LAW_REPORT_FAIL };
}
export function getLawReport(params) {
    return (dispatch) => {
        dispatch(getLawReportRequest());
        return wtsApi.verifications.verificationsList(params)
            .then(({ data }) => {
            dispatch(getLawReportSuccess(data.Data));
            if (!data.Data?.length) {
                toastr.warning(I18n.t('NoDataAvailable'), '');
            }
        })
            .catch((error) => {
            console.error(error);
            dispatch(getLawReportFail());
            toastrError(error);
        });
    };
}
